import React from "react";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const ChooseLanguage = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex gap-5 py-5 px-3">
        <ArrowBack onClick={() => navigate("/profile")} />
        <p className="text-lg">Choose Language</p>
      </div>
      <div className=" px-3 py-3">
        <div className="flex justify-center gap-10 border-2 rounded-xl px-3 py-2">
          <div className="border-2 h-5  w-5 mt-5"></div>
          <p className="mt-5  font-bold">Hindi</p>
        </div>
      </div>
      <div className=" px-3 py-3">
        <div className="flex justify-center gap-10 border-2 rounded-xl px-3 py-2">
          <div className="border-2 h-5  w-5 mt-5"></div>
          <p className="mt-5 font-bold">Tamil</p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/lg.png"
            alt=""
          />
        </div>
      </div>
      <div className=" px-3 py-3">
        <div className="flex justify-center gap-10 border-2 rounded-xl px-3 py-2">
          <div className="border-2 h-5  w-5 mt-5"></div>
          <p className="mt-5  font-bold">English</p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/lg.png"
            alt=""
          />
        </div>
      </div>
      <div className=" px-3 py-3">
        <div className="flex justify-center gap-10 border-2  rounded-xl px-3 py-2">
          <div className="border-2 h-5  w-5 mt-5"></div>
          <p className="mt-5  font-bold">Telugu</p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/lg.png"
            alt=""
          />
        </div>
      </div>
      <div className="px-3 py-6 ">
        <Button className="!w-full text-white" variant="contained">
          Continue
        </Button>
      </div>
    </>
  );
};
export default ChooseLanguage;
